import { useState } from "react";
import { HiOutlineCube } from "react-icons/hi2";
import { handleProductUpdate } from "../services/api";
import { Input, Modal } from "@iq/models";

const requiredMarkStyle = { color: "var(--color-danger)", marginLeft: "2px" };

function EditProductModal({ product, onClose, onInserted }) {
    const [form, setForm] = useState({
        name: product?.name || "",
        description: product?.description || "",
    });
    const [submitting, setSubmitting] = useState(false);
    const [submitError, setSubmitError] = useState("");

    const isFormValid = Boolean(form.name.trim());

    function handleFieldChange(event) {
        const { name, value } = event.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    }

    async function handleSubmit(event) {
        event?.preventDefault?.();
        if (!isFormValid) {
            return;
        }
        setSubmitError("");
        setSubmitting(true);

        try {
            await handleProductUpdate(product?.id, {
                name: form.name.trim(),
                description: form.description.trim(),
            });

            await onInserted?.();
            onClose?.();
        } catch (error) {
            setSubmitError(error?.message || "Failed to update product");
        } finally {
            setSubmitting(false);
        }
    }

    const labelStyle = {
        fontSize: "var(--font-size-xs)",
        fontWeight: 600,
        color: "var(--color-fg-muted)",
        marginBottom: "4px",
        display: "block",
    };

    return (
        <Modal
            isOpen
            onClose={onClose}
            title="Edit Product"
            icon={<HiOutlineCube size={32} />}
            shrink
            errorMessage={submitError}
            actionButtons={[
                {
                    key: "submit",
                    text: submitting ? "Saving..." : "Add +",
                    color: "accent",
                    disabled: submitting || !isFormValid,
                    onClick: handleSubmit,
                },
            ]}
        >
            <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "var(--space-3)", width: "100%" }}>
                <div>
                    <label style={labelStyle} htmlFor="name">
                        Product Name<span style={requiredMarkStyle}>*</span>
                    </label>
                    <Input
                        id="name"
                        name="name"
                        type="text"
                        colorScheme="dark"
                        value={form.name}
                        onChange={handleFieldChange}
                        placeholder="e.g. Cool Website"
                    />
                </div>

                <div>
                    <label style={labelStyle} htmlFor="description">Description:</label>
                    <textarea
                        id="description"
                        name="description"
                        value={form.description}
                        onChange={handleFieldChange}
                        placeholder='E.g. "This website is really cool"'
                        rows={5}
                        style={{
                            width: "100%",
                            resize: "vertical",
                            background: "rgba(239, 255, 246, 0.05)",
                            border: "1px solid var(--color-surface-soft)",
                            borderRadius: "var(--radius-sm)",
                            color: "var(--color-fg-default)",
                            fontSize: "var(--font-size-sm)",
                            fontFamily: "inherit",
                            padding: "10px 12px",
                        }}
                    />
                </div>
            </form>
        </Modal>
    );
}

export default EditProductModal;
